import { OnInit } from '@angular/core';
import { ABTest } from '@freelancer/abtest';
import { Auth } from '@freelancer/auth';
import { Datastore } from '@freelancer/datastore';
import { Feature, FeatureFlagsService } from '@freelancer/feature-flags';
import { ButtonColor } from '@freelancer/ui/button';
import * as Rx from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
var NavigationSecondaryProjectsComponent = /** @class */ (function () {
    function NavigationSecondaryProjectsComponent(locale, auth, abtest, datastore, featureFlagService) {
        this.locale = locale;
        this.auth = auth;
        this.abtest = abtest;
        this.datastore = datastore;
        this.featureFlagService = featureFlagService;
        this.Feature = Feature;
        this.ButtonColor = ButtonColor;
        this.isGiveGetEligible$ = Rx.of(false);
        this.t93229showGiveButtonTestVariation$ = Rx.of(false);
    }
    NavigationSecondaryProjectsComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.isGiveGetEligible$ = this.datastore
            .document('referralInvitationCheck', this.auth.getUserId())
            .valueChanges()
            .pipe(map(function (result) { return result.isEligible; }));
        this.userCountry$ = this.datastore
            .document('usersSelf', this.auth.getUserId())
            .valueChanges()
            .pipe(map(function (result) {
            return result.address !== undefined && result.address.country !== undefined
                ? result.address.country
                : '';
        }));
        // T93229: AB test for give button on logged in navbar
        // https://www.freelancer.com/admin/abtest/index.php?action=show_experiment&experiment_id=1017
        this.t93229showGiveButtonTestVariation$ = Rx.combineLatest([
            this.isGiveGetEligible$,
            this.userCountry$,
            this.featureFlagService.getFlag(Feature.GIVE_GET),
        ]).pipe(switchMap(function (_a) {
            var isGiveGetEligible = _a[0], userCountry = _a[1], featureFlag = _a[2];
            // Exclude the user from enrollment when whitelist cookie is set
            // while still showing them the test variant.
            if (_this.abtest.isWhitelistUser()) {
                return Rx.of(true); // test variant.
            }
            if (
            // Do not enrol user who is outside of US.
            userCountry !== 'United States' ||
                // Do not enrol non-English user into the test.
                !_this.locale.startsWith('en') ||
                // Do not enrol enterprise user to the test.
                !featureFlag ||
                // Do not enrol user who is ineligible to the give get program.
                !isGiveGetEligible) {
                return Rx.of(false); // control variant.
            }
            // Enroll the user to the experiment.
            return _this.abtest
                .getUserExperimentVariation('T93229-logged-in-navbar-give-button')
                .pipe(map(function (variation) { return variation === 'test'; }));
        }));
    };
    return NavigationSecondaryProjectsComponent;
}());
export { NavigationSecondaryProjectsComponent };
